<template>
  <PostPackageGroupsDatatable
      :post-indexes="postIndexes"
      :post-package-groups="postPackageGroups"
      :loading="loading"
      :total="total"
      @update="onUpdate"
  />
</template>

<script>
import PostPackageGroupsDatatable from '@/components/PostPackageGroupsDatatable'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import PostPackageGroupService from "@/services/post.package.group.service";
import Moment from "moment";
import _ from "underscore";
import Mapper from "@/mappers";
import PostIndexService from "@/services/post.index.service";
import {AllowCreatePackageGroup} from "@/enums/permission";

export default {
  name: "PostPackageGroupsView",
  components: {
    PostPackageGroupsDatatable
  },
  data() {
    return {
      postIndexes: [],
      postPackageGroups: [],
      total: 0,
      loading: false
    }
  },
  computed: {
    isAllowPostPackageGroupsListing() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePackageGroup
      })
    },
  },
  methods: {
    onUpdate(options, filters) {
      this.reloadPostPackageGroups(options, filters)
    },
    reloadPostPackageGroups(options, filters) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {sortBy, sortDesc, page, itemsPerPage} = options;
      const {region, start, end, postIndex} = filters;

      const skip = (page - 1) * itemsPerPage;

      PostPackageGroupService.getDatatable({
        skip: skip,
        limit: itemsPerPage,
        sort: sortBy.length === 1 ? sortBy[0] : null,
        desc: sortDesc.length === 1 ? sortDesc[0] : null,
        region: region,
        start: start ? Moment(start, 'YYYY-MM-DD') : null,
        end: end ? Moment(end, 'YYYY-MM-DD') : null,
        postIndex: postIndex
      })
          .then(response => {
            this.postPackageGroups = _.map(response.data.Records, postPackageGroupViewModel => {
              return Mapper.mapPostPackageGroup(postPackageGroupViewModel)
            })

            this.total = response.data.Total;
          }, () => {

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadPostIndexes() {
      PostIndexService.getAll({})
          .then(response => {
            this.postIndexes = _.map(response.data, Mapper.mapPostIndex)
          })
    }
  },
  created() {
    if (this.isAllowPostPackageGroupsListing) {
      this.loadPostIndexes()
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Сводные реестры')
    } else {
      this.$router.go(-1)
    }
  }
}
</script>